import { Box } from '@mui/material'
import { Button, IconInterax } from '../../interaxDesignSystemComponents'
import { INTERAX_COLORS } from '../../constants/colors'

interface FAQGuideCardProps {
  icon: React.ReactNode
  title: string
  description: string
  buttonText: string
  buttonIcon?: React.ReactNode
  onButtonClick: () => void
}

export default function FAQGuideCard({
  icon,
  title,
  description,
  buttonText,
  buttonIcon,
  onButtonClick
}: FAQGuideCardProps) {
  return (
    <Box
      sx={{
        backgroundColor: INTERAX_COLORS.heritageBlue40,
        borderRadius: '8px',
        padding: '24px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between'
      }}
    >
      {/* Row with icon, title and description */}
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: '16px', flex: 1 }}>
        {/* Icon */}
        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexShrink: 0 }}>
          <IconInterax backgroundShape="square" size="medium">
            {icon}
          </IconInterax>
        </Box>

        {/* Content Column */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', flex: 1, minWidth: 0 }}>
          <Box className="text-headline-4" sx={{ color: INTERAX_COLORS.white }}>
            {title}
          </Box>
          <Box className="text-body-2" sx={{ color: INTERAX_COLORS.thunderGrey }}>
            {description}
          </Box>
        </Box>
      </Box>

      {/* Full width centered button at bottom */}
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '16px' }}>
        <Button variant="primary" onClick={onButtonClick} icon={buttonIcon} iconPosition="right" fullWidth>
          {buttonText}
        </Button>
      </Box>
    </Box>
  )
}
